export default __webpack_public_path__ + "static/media/footer-ssl.c24fe29a.png";